// Libs
// import jQuery from 'jquery'
// import Swal from 'sweetalert2';
// import flatpickr from 'flatpickr';
// import jQuery from 'jquery';

import ModuleForms from "./Public/ModuleForms";
import ModuleSwiper from "./Public/ModuleSwiper";
import ModulePopup from "./Public/ModulePopup";
import Accordion from "./Public/Accordion";
import ModuleFancybox from "./Public/ModuleFancybox";
import ModuleTab from "./Public/ModuleTab";
import Upload from "./Public/Upload";
import Wysiwyg from "./Public/Wysiwyg";

import ModuleCalcElement from "./Public/ModuleCalcElement";
import CountNumbers from "./Public/CountNumbers";
import Header from "./Layouts/Header";
import ListTable from "./Layouts/ListTable";
import TableOfContents from "./Public/TableOfContents";
import AnchorScroll from "./Public/AnchorScroll";
import SVGImport from "./Public/SVGImport";
import lazyLoadImages from "./Classes/LazyLoadImages";
import ModuleCountDownFlip from "./Public/ModuleCountDownFlip";
import ModuleSelect2 from "./Public/ModuleSelect2";
import ModuleDatePicker from "./Public/ModuleDatePicker";
import ModuleQuanlity from "./Public/ModuleQuanlity";

import BraneyPopup from "./Public/BraneyPopup";
import BraneySelect from "./Public/BraneySelect";
window.BraneyPopup = BraneyPopup;


// import Wysiwyg from "./Public/Wysiwyg";
// import Observerjs from "./Classes/Observerjs";
// import ModuleSelect2 from "./Public/ModuleSelect2";
// import TableOfContents from "./Public/TableOfContents";
// import ModuleCopyToClipboard from "./Public/ModuleCopyToClipboard";
// import Header from "./Layouts/Header";
// import ModuleEffects from "./Public/ModuleEffects";
// import CallAPI from "./Public/CallAPI";
// import ModuleMaps from "./Public/ModuleMaps";

const BraneyModulesManager = {
    runModule: function () {
        // new TableOfContents();

        new ModuleSwiper();
        new ModuleFancybox();
        new Upload();
        new ModuleCountDownFlip();
        new ModuleSelect2();
        new ModuleDatePicker();
        
        new ModuleForms();
        // new ModulePopup();
        // new Accordion();
        // new ModuleTab(document.querySelector('.js-tab-popup'));
        // new Header();
        // new SVGImport().init();
        // new lazyLoadImages();
        
        
        // new ModuleTab(document.querySelector('.js-tab-post'));
        // new ModuleMaps();
        
        new Wysiwyg();
        new ListTable();
        new AnchorScroll();
        new ModuleQuanlity();
        // new ModuleSelect2();
        // new TableOfContents();
        // new ModuleCopyToClipboard().init();
        // new ModuleTab(document.querySelector('.js-tab-khang'));
        // document.querySelectorAll('.js-machine-tabs')?.forEach((item)=> {
        //     new ModuleTab(item);
        // })

        new Header();
        // new ModuleEffects();
        // new Observerjs().init();
        // new CallAPI().init();

        new ModuleCalcElement();
        new CountNumbers().init();

        new BraneySelect();

        document.body.style.opacity = "";

        // Add MutationObserver
        const observer = new MutationObserver(function (mutationsList, observer) {
            for (const mutation of mutationsList) {
                if (mutation.addedNodes.length) {
                    mutation.addedNodes.forEach(node => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            if (node.classList.contains('swiper')) {
                                new ModuleSwiper();
                            }
                            node.querySelectorAll('.swiper').forEach(function (item) {
                                new ModuleSwiper();
                            })
                        }
                    });
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });

        // Swal.fire({ showClass: "", 
        //     title: "Thank you!", 
        //     text: "That thing is still around?",
        //     icon: "success", 
        //     showCloseButton: true, confirmButtonText: 'Download Our PDF Catalog',
        // }).then((result) => { 
        //     if (result.isConfirmed) {
        //         // thay link bằng link PDF hoặc link bạn muốn mở
        //         window.location.href = "https://example.com/catalog.pdf";
        //     }
        // });

    }
};

document.addEventListener('DOMContentLoaded', function () {
    BraneyModulesManager.runModule();

    if ('serviceWorker' in navigator) {
        navigator.serviceWorker.register('./sw.js')
            .then(reg => console.log('Saigon Co.op Registered', reg))
            .catch(err => console.error('Saigon Co.op Error', err));

        window.addEventListener('beforeinstallprompt', (e) => {
        });
    }
})